import React from "react";
import * as PropTypes from "prop-types";
import {Toolbar, Typography, withStyles} from "@material-ui/core";
import classNames from "classnames";
import {lighten} from "@material-ui/core/styles";

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
        justifyContent: 'space-between',
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
        width: 'calc(50% + 125px)',
        [theme.breakpoints.down('sm')]: {
            width: '50%',
        }
    },
    title: {
        flex: '0 0 auto',
    },
});

function EnhancedTableToolbar(props) {
        const {numSelected, classes} = props;
        return (
            <Toolbar
                className={classNames(classes.root, {
                    [classes.highlight]: numSelected > 0,
                })}
            >
                    <div className={classes.title}>
                        {numSelected > 0 ? (
                            <Typography color="inherit" variant="subtitle1">
                                {numSelected} selecionado(s)
                            </Typography>
                        ) : (
                            <Typography variant="h6" id="tableTitle">
                                {
                                    props.tableTitle || ''
                                }
                            </Typography>
                        )}
                    </div>
                    <div className={classes.actions}>
                        {numSelected > 0 ?
                            props.selectActions
                            : (
                                props.topActions
                            )}
                    </div>

            </Toolbar>
        );
    };


EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object,
    numSelected: PropTypes.number.isRequired,
    tableTitle: PropTypes.string,
    selectActions: PropTypes.element,
    topActions: PropTypes.any,
};

export default withStyles(toolbarStyles)(EnhancedTableToolbar);
